/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  firebase : {
    apiKey: "AIzaSyC0ef7VEwTQJT3vahm8l4BJmv2SVRJv0wQ",
    authDomain: "vibesign-e3c2a.firebaseapp.com",
    projectId: "vibesign-e3c2a",
    storageBucket: "vibesign-e3c2a.appspot.com",
    messagingSenderId: "911207320375",
    appId: "1:911207320375:web:156b5632934f17399028b2",
    measurementId: "G-R7Z3ZPXH9F"
  }
};